export const QueryKeys = {
  // Top-level keys
  ACCOUNTS: 'ACCOUNTS',
  USERS: 'USERS',
  COURIERS: 'COURIERS',
  CUSTOMERS: 'CUSTOMERS',
  INVITATIONS: 'INVITATIONS',
  ORDERS: 'ORDERS',
  PROJECTS: 'PROJECTS',
  DELIVERY_CONTAINERS: 'DELIVERY_CONTAINERS',
  DELIVERY_CONTAINER_ACCESS_LAYERS: 'DELIVERY_CONTAINER_ACCESS_LAYERS',
  TOWER_MODELS: 'TOWER_MODELS',
  TOWERS: 'TOWERS',
  HUBS_DETAILS: 'HUBS_DETAILS',
  HUBS: 'HUBS',
  KIOSKS: 'KIOSKS',
  WHOAMI: 'WHOAMI',
  CHECKMYPERMISSION: 'CHECKMYPERMISSION',
  REPORTS: 'REPORTS',
  GROUPS: 'GROUPS',
  DELIVERIES: 'DELIVERIES',
  DASHBOARD: 'DASHBOARD',
  NOTIFICATIONS: 'NOTIFICATIONS',
  PARTIES: 'PARTIES',
  NOTES: 'NOTES',
  SETTINGS: 'SETTINGS',
  SETTINGS_CHILDREN: 'SETTINGS_CHILDREN',
  SETTINGS_SCHEMAS: 'SETTINGS_SCHEMAS',
  ACCESS_CONTROL: 'ACCESS_CONTROL',
  CARRIERS: 'CARRIERS',
  LIST: 'LIST',
  HIERARCHY: 'HIERARCHY',
  SERVICING: 'SERVICING',
  MODULES: 'MODULES',
  PROJECT_MODULES: 'PROJECT_MODULES',
  REGISTRATION_PAGES: 'REGISTRATION_PAGES',

  // Action keys
  CHILD_PROJECTS: 'CHILD_PROJECTS',
  TEAM_MEMBERS: 'TEAM_MEMBERS',
  TIMELINE: 'TIMELINE',
  IS_MEMBER_OF_GROUPS: 'IS_MEMBER_OF_GROUPS',
  CURRENT_STATS: 'CURRENT_STATS',
  HISTORIC_ORDER_STATS: 'HISTORIC_ORDER_STATS',
  TIME_IN_LOCKER_STATS: 'TIME_IN_LOCKER_STATS',
  CURRENT_HUB_STATS: 'CURRENT_HUB_STATS',
  ADD_NOTE: 'ADD_NOTE',
  CAN_I_OPEN_LOCKER: 'CAN_I_OPEN_LOCKER',

  DELIVERY_CONTAINER_CONTENTS: 'DELIVERY_CONTAINER_CONTENTS',
  DELIVERY_CONTAINER_CONTENTS_HISTORY: 'DELIVERY_CONTAINER_CONTENTS_HISTORY',

  DELIVERIES_REPORT: 'DELIVERIES_REPORT',
  DELIVERIES_REQUIRING_ATTENTION: 'DELIVERIES_REQUIRING_ATTENTION',
  LOCKER_UTILISATION: 'LOCKER_UTILISATION',
  DELIVERY_CONTAINER_UTILISATION: 'DELIVERY_CONTAINER_UTILISATION',
  DELIVERY_CONTAINER_CAPACITY: 'DELIVERY_CONTAINER_CAPACITY',

  SUMMARY: 'SUMMARY',

  ENTITY_HISTORY: 'ENTITY_HISTORY',
  TRANSACTION_TYPES: 'TRANSACTION_TYPES',
  CAPABILITIES: 'CAPABILITIES',
  OCCUPANT_SEARCH: 'OCCUPANT_SEARCH',

  SEARCH: 'SEARCH'
};
